<script setup>

import {onMounted, ref, watch} from "vue";
import Repository from "../../Helpers/Repository";
import {useI18n} from "vue-i18n";
import Language from "../../Helpers/Language";
import FilterDTO from "../DTO/FilterDTO";

const {t} = useI18n();

const props = defineProps({
    eventDays: Array,
    stages: Array,
    stageId: Number,
    isDisabled: Boolean,
});

const tags = ref([]);
const emits = defineEmits(['filterSchedules']);

const activeDay = ref(null);
const activeStage = ref(null);
const activeTag = ref(null);
const rawSearch = ref(null);

onMounted(() => {
    new Repository().getTags().then((response) => {
        tags.value = response.data;
    });
});

const filterDay = (day) => {
    if (activeDay.value === day) {
        return;
    }

    activeDay.value = day;
    activeTag.value = null;
    activeStage.value = null;
    rawSearch.value = null;
    emits('filterSchedules', filterSchedules());
}

watch(() => {
    if (activeDay.value === null && props.eventDays.length > 0) {
        activeDay.value = props.eventDays[0];
    }
});

const filterSchedules = () => {
    return new FilterDTO(
        activeDay.value,
        rawSearch.value,
        activeStage.value,
        activeTag.value,
    );
}

const formatDayLabel = (day) => {
    return new Date(`${day} 00:00:00`).toLocaleDateString(Language.getLanguage() ?? null, {
        day: "numeric",
        month: "long",
    });
}

</script>

<template>
    <header v-if="!isDisabled">
        <ul>
            <li v-for="day in eventDays">
                <button :class="{'active': activeDay === day}" type="button" @click="filterDay(day)">
                    {{ formatDayLabel(day) }}
                </button>
            </li>
        </ul>
        <form>
            <span>{{ t('Filtrar por') }}</span>
            <label>
                <select v-if="stages.length > 1" name="palco" v-model="activeStage">
                    <option :value="null" :selected="activeStage === null">{{ t('Palco') }}</option>
                    <option v-for="stage in stages" :value="stage['id']">{{ stage['name'] }}</option>
                </select>
                <input :placeholder="t('Buscar por palavra-chave')" name="search" v-model="rawSearch">
            </label>
            <button type="button" @click="$emit('filterSchedules', filterSchedules())">{{ t('Buscar') }}</button>
        </form>
        <span>*{{ t('Programação sujeita a alteração') }}</span>
    </header>
</template>
